import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="studio-bg grain min-h-screen grid place-items-center px-5">
      <div className="glass rounded-3xl p-10 text-center max-w-md fade-up" data-testid="payment-cancel">
        <XCircle className="w-16 h-16 text-slate-500 mx-auto" />
        <h1 className="font-display text-2xl font-bold mt-5">Paiement annulé</h1>
        <p className="text-slate-400 mt-2">Aucun montant n'a été débité.</p>
        <Button onClick={() => navigate("/pricing")} className="mt-6 h-11 px-6 bg-[#3ECF8E] hover:bg-[#2fb879] text-black glow-btn rounded-full font-semibold">
          Retour aux tarifs
        </Button>
      </div>
    </div>
  );
}
